import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';
import ModalPermissionsComponent from '@/components/modal-permissions/modal-permissions.component.vue';
import ModalLoginComponent from '@/components/modal-login/modal-login.component.vue';
//service
import SurveyService from '@/core/services/survey.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    ModalPermissionsComponent,
    ModalLoginComponent,
    LoaderComponent
  }
})
export default class EditSurveyComponent extends Vue {

  surveyService: any = new SurveyService();
  sidebarService: any = new SidebarService();
  isLoading: boolean = false;
  logInModal: boolean = false;
  showModal: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  modal: boolean = false;
  error: boolean = false;
  genericErr: any = [];
  name: string = "";
  description: string = "";
  instructions: string = "";

  mounted (){
    const _ = this;
    _.getById();
  }

  closeSidebar(){
    const _ = this;
    _.sidebarService.close();
  }

  edit(){
    const _ = this;
    let survey = {
      name: _.name,
      description: _.description,
      instructions: _.instructions

    };
    let idSurvey: any = location.href.split("/");
    idSurvey = idSurvey[5];
    _.isLoading = true;
    _.surveyService.edit(survey, idSurvey).then((data: any) => {
      _.isSuccess = true;
      _.isErrorServer = false;
      _.error = false;
      _.modal = true;
      setTimeout(() => {
        _.isLoading = false;
        _.$router.push('/survey');
      }, 1500)
    })
    .catch((err: any) => {
      _.modal = true;
      _.error = true;
      _.isErrorServer = true;
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }

  getById(){
    const _ = this;
    let idSurvey: any = location.href.split("/");
    idSurvey = idSurvey[5];
    _.isLoading = true;
    _.surveyService.getById(idSurvey).then((data: any) => {
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
      _.name = data["data"].survey.name;
      _.description = data["data"].survey.description;
      _.instructions = data["data"].survey.instructions;
    })
    .catch((err: any) => {
      if(err.response.data.message.includes('Invalid or inexistent user')){
        localStorage.removeItem('tk_auth');
        _.logInModal = true;
        console.log(_.logInModal, '_.logInModal')
      }
      setTimeout(() => {
        _.isLoading = false;
      }, 1500)
    })
  }

  validations(name = '', instructions = '', description = ''){
    const _ = this;
    _.genericErr = [];
    if(name == ''){
      _.genericErr.push("Por favor escribe el nombre");
    }
    if(instructions == ''){
      _.genericErr.push("Por favor escribe las instructions");
    }
    if(description == ''){
      _.genericErr.push("Por favor escribe una descripción");
    }
    if(_.genericErr.length > 0){
      _.modal = true;
      _.error = true;
      return;
    }
    _.edit()
  }

}
